import React from "react";
import { map } from "lodash";
import {
  Container,
  Bloc,
  StepContainer,
  TextContainer,
  Title,
  Step,
} from "./styled-components";
import Text from "../text";

const StepsBloc = () => {
  const options = {
    title: "Quelles sont les prochaines étapes ?",
    steps: [
      {
        title: "Vous pouvez nous saisir de trois manières différentes :",
        description: (
          <ul>
            <li>
              En remplissant le formulaire en ligne en cliquant sur "Créer mon
              dossier"
            </li>
            <li>
              En rencontrant un délégué dans l’un de nos lieux de permanence :{" "}
              <a
                href="https://www.defenseurdesdroits.fr/fr/saisir/delegues"
                target="_blank"
                rel="noreferrer"
              >
                Annuaire délégués
              </a>{" "}
            </li>
            <li>
              En envoyant un courrier gratuitement, sans mettre de timbre sur
              l'enveloppe à l’adresse suivante :{" "}
              <Text weight={700} lineHeight="26px">
                Défenseur des droits <br /> Libre réponse 71120 <br /> 75342
                Paris CEDEX 07
              </Text>
            </li>
          </ul>
        ),
      },
      {
        title: "Des juristes étudient votre dossier",
      },
      {
        title: "Les juristes vous répondent après avoir étudié votre dossier",
      },
    ],
  };

  return (
    <Container>
      <Title>
        <Text size="24px" lineHeight="24px" weight={700}>
          {options.title}
        </Text>
      </Title>
      {map(options.steps, ({ title, description }, index) => (
        <Bloc key={index} index={index}>
          <StepContainer>
            <Step>
              <Text color="blue" size="24px" weight={700}>
                {index + 1}
              </Text>
            </Step>
          </StepContainer>
          <TextContainer>
            <Text size="18px" lineHeight="20px" weight={600}>
              {title}
            </Text>
            {description && <Text>{description}</Text>}
          </TextContainer>
        </Bloc>
      ))}
    </Container>
  );
};

export default StepsBloc;
